import React, { useCallback } from 'react';
import { Button, Pagination, Spin } from '@peoplegrove/pg-components';
import { useUserFeedbackFiltersContext } from '../../context/UserFeedbackFiltersContext';
import useFetchUserFeedback from '../../hooks/useFetchUserFeedback';
import useDownloadUserFeedbackCSVMutation from '../../queries/useDownloadUserFeedbackCSVMutation';
import UserFeedbackFilters from './UserFeedbackFilters';
import UserFeedbackList from './UserFeedbackList';
import classes from './UserFeedback.module.scss';

const UserFeedback = ({ setSelectedSessionAddress }) => {
  const { userFeedbackFilters, updatePage } =
    useUserFeedbackFiltersContext();
  const { mutate: downloadCSV, isLoading: isDownloading } =
    useDownloadUserFeedbackCSVMutation();

  const { data: userFeedbackData, isLoading, error } = useFetchUserFeedback();

  const handleDownloadCSV = useCallback(() => {
    downloadCSV(userFeedbackFilters);
  }, [downloadCSV, userFeedbackFilters]);

  const handlePaginationChange = useCallback(
    pagination => {
      if (pagination !== userFeedbackFilters.page) {
        updatePage(pagination);
      }
    },
    [userFeedbackFilters.page, updatePage]
  );

  if (isLoading) {
    return <Spin size={24} />;
  }

  return (
    <div className="ck-card">
      <div className={classes.userFeedbackHeader}>
        <h2>User feedback for Sage</h2>
        <Button
          type="secondary"
          size="small"
          icon="pg-download-o"
          onClick={handleDownloadCSV}
          disabled={isDownloading || userFeedbackData?.conversations?.length === 0}
          loading={isDownloading}
        >
          {isDownloading ? 'Downloading...' : 'Export to CSV'}
        </Button>
      </div>
      <UserFeedbackFilters />

      {userFeedbackData?.conversations.length === 0 && (
        <div className={classes.noFeedbackFound}>No feedback found</div>
      )}

      <UserFeedbackList
        setSelectedSessionAddress={setSelectedSessionAddress}
        userFeedbackData={userFeedbackData}
        isLoading={isLoading}
      />

      <Pagination
        currentPage={userFeedbackFilters.page}
        pageSize={userFeedbackFilters.limit}
        totalCount={userFeedbackData?.totalCount || 0}
        onPageChange={handlePaginationChange}
      />
    </div>
  );
};

export default UserFeedback;
